import { Table, Badge, Alert } from "react-bootstrap";

function TaskTables({ currentTaskPrefs, newTaskPrefs }) {
  return (
    <>
      <h5 className="mb-3">Huidige taken</h5>
      {currentTaskPrefs.length === 0 ? (
        <Alert variant="info">Geen taken toegewezen.</Alert>
      ) : (
        <Table bordered hover>
          <thead>
            <tr>
              <th>Taak</th>
              <th>Wil voortzetten</th>
              <th>Opmerking</th>
            </tr>
          </thead>
          <tbody>
            {currentTaskPrefs.map(({ task, pref }) => {
              const choice = pref?.wantsToDo;
              return (
                <tr key={task.ID}>
                  <td>{task.name}</td>
                  <td>
                    {choice === true ? (
                      <Badge bg="success">Ja, graag</Badge>
                    ) : choice === false ? (
                      <Badge bg="danger">Liever niet</Badge>
                    ) : (
                      <span className="text-muted fst-italic">Niet ingevuld</span>
                    )}
                  </td>
                  <td className="text-muted">{pref?.comment || ""}</td>
                </tr>
              );
            })}
          </tbody>
        </Table>
      )}

      <h5 className="mt-4 mb-1">Nieuwe taken</h5>
      <p className="text-muted small mb-3">Taken waarvoor interesse is opgegeven.</p>
      {newTaskPrefs.length === 0 ? (
        <Alert variant="info">Geen interesse in nieuwe taken uitgedrukt.</Alert>
      ) : (
        <Table bordered hover>
          <thead>
            <tr>
              <th>Taak</th>
              <th>Opmerking</th>
            </tr>
          </thead>
          <tbody>
            {newTaskPrefs.map(({ task, pref }) => (
              <tr key={task.ID}>
                <td>{task.name}</td>
                <td className="text-muted">{pref?.comment || ""}</td>
              </tr>
            ))}
          </tbody>
        </Table>
      )}
    </>
  );
}

export default TaskTables;
